import {
	Card,
	CardContent,
	TableBody,
	TableContainer,
	TableCell,
	TableRow,
	Table,
	Typography,
} from '@mui/material';
import { TOrderDetailProps } from '../types';
import { FC } from 'react';
import { AmountRow } from '../AmountRow';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { EasTableValue } from '../../../../ui/EasTable/EasTableRow/EasTableValue';
import { ETableStructureType } from '../../../../ui/EasTable/types';
import { EasCard } from '../../../../ui/EasCard';

export const AmountBreakdownCard: FC<{
	order: TOrderDetailProps['order'];
	currency: string;
}> = ({ order, currency }) => {
	if (!order) return null;

	return (
		<EasCard id="amount-breakdown-card" title="Amount Breakdown" action={<></>} loading={false}>
			<TableContainer>
				<Table>
					<TableBody>
						{/* <AmountRow
							label="Item Price inc. VAT"
							amount={order.delivery_cost_inclusive_vat > 0 ? }
							currency={currency}
							/> */}
						<TableRow>
							<TableCell sx={{ padding: '5px', borderBottom: 0 }}>Price Inclusive VAT:</TableCell>
							<TableCell align="right" sx={{ padding: '5px', borderBottom: 0 }}>
								<EasTableValue
									value={order.delivery_cost_inclusive_vat > 0}
									type={ETableStructureType.BOOLEAN}
									size="m"
									bold={true}
								/>
							</TableCell>
						</TableRow>

						<AmountRow
							label="Merchandise cost"
							amount={order.total_merch_cost}
							currency={currency}
						/>
						<AmountRow label="Delivery Cost" amount={order.delivery_cost} currency={currency} />
						{/* <AmountRow
								label="Delivery Cost Incl. VAT"
								amount={order.delivery_cost_inclusive_vat}
								currency={currency}
							/> */}
						<AmountRow
							label="Customs Duties"
							amount={order.total_custom_duties}
							currency={currency}
						/>
						<AmountRow label="Total VAT" amount={order.total_vat} currency={currency} />
						<AmountRow
							label="DPO fee"
							amount={order.total_dpo_fee * order.daily_exchange_rate}
							currency={currency}
						/>
						{/* <AmountRow
								label="Customs Procedure Fee"
								amount={order.total_dpo_fee}
								currency={currency}
							/> */}
						{/* {order.landed_cost != null && (
								<AmountRow label="Landed Cost" amount={order.landed_cost} currency={currency} />
							)} */}

						<TableRow>
							<TableCell sx={{ padding: '5px', borderBottom: 0 }} />
							<TableCell sx={{ padding: '5px', borderBottom: 0 }} />
						</TableRow>

						<TableRow>
							<TableCell
								sx={{
									padding: '5px',
									fontWeight: 'bold',
									borderBottom: 0,
									fontSize: '1rem',
									color: 'primary.main',
								}}
							>
								Total Amount:
							</TableCell>
							<TableCell
								align="right"
								sx={{
									padding: '5px',
									fontWeight: 'bold',
									borderBottom: 0,
									fontSize: '1rem',
									color: 'primary.main',
								}}
							>
								<AmountAndCurrency
									amount={order.total_payable_by_fc ?? 0}
									currency={currency}
									size={1}
									bold="bold"
								/>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell
								sx={{
									padding: '5px',
									fontWeight: 'bold',
									borderBottom: 0,
									fontSize: '1rem',
									color: 'primary.main',
								}}
							>
								EAS Fee:
							</TableCell>
							<TableCell
								align="right"
								sx={{
									padding: '5px',
									fontWeight: 'bold',
									borderBottom: 0,
									fontSize: '1rem',
									color: 'primary.main',
								}}
							>
								<AmountAndCurrency
									amount={order.eas_fees_due ?? 0}
									currency={currency}
									size={1}
									bold="bold"
								/>
							</TableCell>
						</TableRow>

						{/* <AmountRow label="EAS Fee incl." amount={order.eas_fees_due} currency={currency} /> */}

						{order.calculated_threshod && +order.calculated_threshod > 0 && (
							<>
								<TableRow>
									<TableCell sx={{ padding: '5px' }} />
									<TableCell sx={{ padding: '5px' }} />
								</TableRow>
								<TableRow>
									<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
										Calculated Import Threshold:
									</TableCell>
									<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
										<AmountAndCurrency
											amount={+order.calculated_threshod}
											currency={
												order.delivery_country === 234 || order.delivery_country === 250
													? 'GBP'
													: 'EUR'
											}
											size={0.9}
										/>
									</TableCell>
								</TableRow>
							</>
						)}

						{order.intrinsic_threshold_exchange_rate > 0 && currency !== 'EUR' && (
							<TableRow>
								<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
									{`Threshold Exchange Rate (${currency} → ${order.delivery_country === 234 || order.delivery_country === 250 ? 'GBP' : 'EUR'}):`}
								</TableCell>
								<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
									<AmountAndCurrency amount={1} currency={currency} size={0.9} afterPoint={0} />
									{' = '}
									<AmountAndCurrency
										amount={order.intrinsic_threshold_exchange_rate}
										currency={
											order.delivery_country === 234 || order.delivery_country === 250
												? 'GBP'
												: 'EUR'
										}
										size={0.9}
										afterPoint={6}
									/>
								</TableCell>
							</TableRow>
						)}

						{order.daily_exchange_rate > 0 && (
							<TableRow>
								<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
									{`Daily Exchange Rate (${currency} → ${order.delivery_country === 234 || order.delivery_country === 250 ? 'GBP' : 'EUR'}):`}
								</TableCell>
								<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
									{order.daily_exchange_rate}
								</TableCell>
							</TableRow>
						)}

						{/* {order.sdr_exchange_rate > 0 && (
								<TableRow>
									<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
										{`SDR Exchange Rate (${currency} → ${order.delivery_country === 234 || order.delivery_country === 250 ? 'GBP' : 'EUR'}):`}
									</TableCell>
									<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
										{order.sdr_exchange_rate}
									</TableCell>
								</TableRow>
							)} */}

						{order.standard_vat_rate != null && (
							<TableRow>
								<TableCell sx={{ padding: '2px', borderBottom: 0 }}>Standard VAT Rate:</TableCell>
								<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
									{order.standard_vat_rate}%
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</EasCard>
	);
};
